var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 0H7.00008C6.31008 0 5.77008 0.35 5.41008 0.88L0.370078 8.45C0.150078 8.79 0.150078 9.22 0.370078 9.56L5.41008 17.12C5.77008 17.64 6.38008 18 7.07008 18H22.0001C23.1001 18 24.0001 17.1 24.0001 16V2C24.0001 0.9 23.1001 0 22.0001 0ZM9.00008 10.5C8.17008 10.5 7.50008 9.83 7.50008 9C7.50008 8.17 8.17008 7.5 9.00008 7.5C9.83008 7.5 10.5001 8.17 10.5001 9C10.5001 9.83 9.83008 10.5 9.00008 10.5ZM14.0001 10.5C13.1701 10.5 12.5001 9.83 12.5001 9C12.5001 8.17 13.1701 7.5 14.0001 7.5C14.8301 7.5 15.5001 8.17 15.5001 9C15.5001 9.83 14.8301 10.5 14.0001 10.5ZM19.0001 10.5C18.1701 10.5 17.5001 9.83 17.5001 9C17.5001 8.17 18.1701 7.5 19.0001 7.5C19.8301 7.5 20.5001 8.17 20.5001 9C20.5001 9.83 19.8301 10.5 19.0001 10.5Z",
    fill: "#272A32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.ec0ff1d2c7e1da5265914b3e28508414.svg";
export { ForwardRef as ReactComponent };